/** Text instructions are stored as a plain string or `{ newText }`. */
export function instructionTextValue(value: unknown): string | null {
  if (typeof value === "string") return value;
  if (value && typeof value === "object" && "newText" in value) {
    const text = (value as { newText?: unknown }).newText;
    if (typeof text === "string") return text;
  }
  return null;
}
